export const store = {
  smoothPointer: {
    current: { x: 0, y: 0 },
    gl: { x: 0, y: 0 },
    glNormalized: { x: 0, y: 0 },
  },
};
